import { httpClient } from "../http/httpClient";

export type Links = {
  _id: string;
  name: string;
  label: string;
  seller: {
    _id: string;
    name: string;
  };
  tables: {
    _id: string;
    type: string;
  }[];
  entry_count: {
    entryAt: Date;
  }[];
  total_transactions: number;
  createdAt: string;
  updatedAt: string;
};

export type GetAllUserLinksResponse = {
  links: Links[];
  pagination: {
    limit: number;
    order: number;
    skip: number;
    sort: string;
    total: number;
  };
  config: {
    details: boolean;
  };
};

export type GetAllUserLinksParams = {
  search?: string;
  limit?: number;
  skip?: number;
  sort?: string;
  order?: number;
};

export const getAllUserLinks = async (params: GetAllUserLinksParams) => {
  const { data } = await httpClient
    .get<GetAllUserLinksResponse>("/self-hire", {
      params,
    })
    .catch((error) => {
      throw error?.response?.data || error;
    });
  return data;
};
